import React, { useCallback, useEffect, useState } from 'react';
import { RiArrowRightSLine, RiArrowLeftSLine } from 'react-icons/ri';
import './HeroStyling.css';

const AUTO_ADVANCE_MS = 6000;

const Hero = ({ slides }) => {
  const [current, setCurrent] = useState(0);
  const length = slides.length;

  const nextSlide = useCallback(() => setCurrent(c => (c === length - 1 ? 0 : c + 1)), [length]);
  const prevSlide = useCallback(() => setCurrent(c => (c === 0 ? length - 1 : c - 1)), [length]);

  // Auto-advance
  useEffect(() => {
    const timer = setInterval(nextSlide, AUTO_ADVANCE_MS);
    return () => clearInterval(timer);
  }, [nextSlide]);

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowRight') nextSlide();
      else if (e.key === 'ArrowLeft') prevSlide();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [nextSlide, prevSlide]);

  const currentLabel = String(current + 1).padStart(2, '0');
  const totalLabel = String(length).padStart(2, '0');

  return (
    <section className="hero-page">
      <div className="hero-wrapper">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`hero-slide${index === current ? ' active' : ''}`}
            aria-hidden={index !== current}
          >
            <div className="slide">
              <div className="hero-content">
                <div className="text-wrapper">
                  <h1>{slide.title}</h1>
                </div>
                <p>{slide.description}</p>
              </div>
              <div className="slide-numbers">
                <span className="slide-number">{currentLabel}</span>
                <div className="slide-number-divider" />
                <span className="slide-number-total">{totalLabel}</span>
              </div>
              <img src={slide.image} alt={slide.alt} className="bg-image" loading={index === 0 ? 'eager' : 'lazy'} />
            </div>
          </div>
        ))}

        <button className="slider-btn slider-btn--prev" onClick={prevSlide} aria-label="Previous slide">
          <RiArrowLeftSLine />
        </button>
        <button className="slider-btn slider-btn--next" onClick={nextSlide} aria-label="Next slide">
          <RiArrowRightSLine />
        </button>
      </div>
    </section>
  );
};

export default Hero;
